// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.prof-name {
    font-size: 20px;
    color: var(--secondary-color);
}

.search-group.last-child {
    display: flex;
    flex-direction: row;
    gap: 20px;
}

.language-radio {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 5px;
}

.language-radio > input {
    width: 15px;
    height: 15px;
    margin: 0;
    outline: none;
    border: none;
}

.filter-container {
    display: flex;
    gap: 30px;
}

.update-resume {
    width: 140px;
    height: 50px;
    font-size: 1rem;
}

.add-activity {
    width: 140px;
    height: 50px;
    font-size: 1rem;
    background-color: var(--success-color);
}

.add-activity:hover {
    background-color: rgb(5, 142, 5);
}

.filter-button-container {
    gap: 20px;
}

.action-button.update.resume {
    width: 120px;
}

.type-container {
    width: 20%;
}

.publish-container {
    width: 10%;
}

.action-container {
    width: 20%;
}`, "",{"version":3,"sources":["webpack://./src/pages/ResumeManagement/ResumeManagement.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,SAAS;IACT,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd","sourcesContent":[".prof-name {\n    font-size: 20px;\n    color: var(--secondary-color);\n}\n\n.search-group.last-child {\n    display: flex;\n    flex-direction: row;\n    gap: 20px;\n}\n\n.language-radio {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 5px;\n}\n\n.language-radio > input {\n    width: 15px;\n    height: 15px;\n    margin: 0;\n    outline: none;\n    border: none;\n}\n\n.filter-container {\n    display: flex;\n    gap: 30px;\n}\n\n.update-resume {\n    width: 140px;\n    height: 50px;\n    font-size: 1rem;\n}\n\n.add-activity {\n    width: 140px;\n    height: 50px;\n    font-size: 1rem;\n    background-color: var(--success-color);\n}\n\n.add-activity:hover {\n    background-color: rgb(5, 142, 5);\n}\n\n.filter-button-container {\n    gap: 20px;\n}\n\n.action-button.update.resume {\n    width: 120px;\n}\n\n.type-container {\n    width: 20%;\n}\n\n.publish-container {\n    width: 10%;\n}\n\n.action-container {\n    width: 20%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
